import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Card from '../../../../Components/Card/Card';
import Spinner from '../../../../Components/Fundamentals/Spinner/Spinner';
import SkynetIcon from '../../../../Components/Fundamentals/SkynetIcon';
import ConfirmDeleteModal from '../../../../Components/Modals/ConfirmDeleteModal/ConfirmDeleteModal';
import { TerminationReasonForm } from '../../../../Components/InternalCustomerAdmin/TerminationReasons/TerminationReasonsForm';

import useModal from '../../../../Hooks/useModal';

import terminationReasonsActions from '../../../../Actions/InternalCustomerAdmin/terminationReasonsActions';
import commonActions from '../../../../Actions/commonActions';

import Modals from '../../../../Constants/modals';
import routes from '../../../../Constants/routes';

function TerminationReasonFormContainer({ ...props }) {
    const { terminationReasonsActions, commonActions, terminationReasonForm, isEdit } = props;
    const [searchParams] = useSearchParams();
    const { t } = useTranslation();
    const { openModal, isModalOpen, closeModal } = useModal();
    const navigate = useNavigate();
    
    const [salesChannels, setSalesChannels] = useState([]);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const reasonId = searchParams.get('ReasonId');
    const parentId = searchParams.get('ParentId');

    const shouldShowSpinner = isLoading || !terminationReasonForm;

    useEffect(() => {
        setIsLoading(true);
        terminationReasonsActions.getTerminationReasons();
        terminationReasonsActions.getTerminationReasonForEdit(reasonId, parentId);

        terminationReasonsActions.getSalesChannels((json) => {
            setSalesChannels(json);
            setIsLoading(false);
        });

        return () => {
            commonActions.cancelFormEditing('terminationReasonForm');
        };
    }, []);

    const onDeleteSuccess = () => {
        setIsDeleting(false);
        closeModal();
        navigate(routes.icaTerminationReasons);
    };

    const onDeleteError = () => {
        setIsDeleting(false);
    };

    const performDelete = () => {
        setIsDeleting(true);
        terminationReasonsActions.deleteTerminationReason(terminationReasonForm.data.id, onDeleteSuccess, onDeleteError);
    };

    return (
        <Card>
            {!shouldShowSpinner && (
                <Card.Header>
                    <div className="d-flex justify-content-between align-items-center w-100">
                        <Card.Header.Title>
                            {isEdit
                                ? t('terminationreasonsform.editreason')
                                : terminationReasonForm?.data.parentId
                                ? t('terminationreasonsform.createsubreason')
                                : t('terminationreasonsform.createreason')}
                        </Card.Header.Title>

                        {isEdit && (
                            <span className="mb-8">
                                <SkynetIcon icon={'vismaicon-delete'} title={t('common.delete')} onClick={() => openModal(Modals.ConfirmDeleteModal)} />
                            </span>
                        )}
                    </div>
                </Card.Header>
            )}
            <Card.Content>
                {shouldShowSpinner ? (
                    <Spinner />
                ) : (
                    <>
                        <TerminationReasonForm salesChannels={salesChannels} {...props} />

                        {isModalOpen(Modals.ConfirmDeleteModal) && (
                            <ConfirmDeleteModal
                                title={t('terminationreasonscontainer.terminationReasonDeleteModalHeader')}
                                itemName={terminationReasonForm?.data.name}
                                onSubmit={performDelete}
                                isLoading={isDeleting}
                            />
                        )}
                    </>
                )}
            </Card.Content>
        </Card>
    );
}

function mapDispatchToProps(dispatch) {
    return {
        commonActions: bindActionCreators(commonActions, dispatch),
        terminationReasonsActions: bindActionCreators(terminationReasonsActions, dispatch),
    };
}

function mapStateToProps(state) {
    return {
        terminationReasonForm: state.CommonReducer.forms && state.CommonReducer.forms.terminationReasonForm,
        terminationReasons: state.InternalCustomerAdminReducer.terminationReasons,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TerminationReasonFormContainer);
